<template>
    <div class="vm-order">
        <template v-if="order.user">
            <avatar :user="order.user" :name_center="true" class="wh48" :is_href_blank="true">
                <div slot="name-right" class="fs12 black-5 fwn" v-if="order.order_attr && order.order_attr.express_status == 8">
                    {{$t('c.Order.text1')}}
                </div>
                <div slot="name-right" class="fs12 black-5 fwn" v-if="order.order_attr && order.order_attr.express_status == 9">
                    {{$t('c.Order.text2')}}
                </div>
            </avatar>
            <!-- 没有自动回复、没有附件、没有关联作品集、没有富文本、没有新的这个动态 -->
            <div class="item mb8" v-for="(item,i) in order.sku_processed" :key="i">
                <plan-sale @click.native="item_jump" class="mt16 look3" :class="{'white-bg': order.plan.product_type == 4}" :plan="order.plan" :sku_count="item.count" :cover="item.pic" :name="item.name" :cover_w="order.plan.product_type == 4 ? 88 : 64" :cover_h="order.plan.product_type == 4 ? 88 : 64" :is_show_bundle="false" :order="order" :is_show_amount="false">
                  <btn v-if="item.sku_id && item.post && item.post.post_id" class="pt8 pr12 pb8 pl12 fs14" @click.native.stop="$mixin_router_push(`/p/${item.post.post_id}`, true)">{{$t('c.Order.text3')}}</btn>
                  <btn v-else-if="item.sku_id && !item.post && item.post_id" class="pt8 pr12 pb8 pl12 fs14" @click.native.stop="$notify({title: $t('c.Order.text4') ,group: 'success'})">{{$t('c.Order.text3')}}</btn>
                  <btn v-else-if="item.has_reply == 1 && item.attachment.length == 0 && item.has_rich_text == 0 && (!item.album || item.album && !item.album.album_id)" class="pt8 pr12 pb8 pl12 fs14" @click.native.stop="$mixin_router_push(`/message/${order.user.user_id}?is_keyboard_up=1`, true)">{{$t('c.Order.text3')}}</btn>
                  <btn v-else-if="item.has_reply == 0 && item.has_rich_text == 0 && item.album && item.album.album_id && item.attachment.length == 0" class="pt8 pr12 pb8 pl12 fs14" @click.native.stop="$mixin_router_push(`/album/${item.album_id}`, true)">{{$t('c.Order.text3')}}</btn>
                  <i v-else-if="item.has_reply == 0 && item.attachment.length == 0 && item.has_rich_text == 0 && !item.album_id && !item.post_id"></i>
                  <btn v-else class="pt8 pr12 pb8 pl12 fs14" @click.native.stop="$mixin_router_push(`/purchase/sku/${item.sku_id}`, true)">{{$t('c.Order.text3')}}</btn>
                </plan-sale>
            </div>
            <template v-if="order.plan.product_type == 4">
              <div  class="mt16 flex-box flex-center relative w100" style="height:64px;overflow: hidden;">
                <img class="self-center" :src="`${GL.PIC_HOST}/static/img/qr-code-ticket.png`" alt />
                <btn class="pt12 pb12" @click.native="open_qr">查看电子票</btn>
              </div>
              <ticket-tip class="mt16"/>
              <div class="line mt-24-16 mq"></div>
            </template>
        </template>
        <div class="order-info">
            <div class="flex-item-1">
                <div class="mt8 fwb" v-if="order.plan.plan_id">
                    <span class="break-all" @click="tit_jump">{{ order.plan.name }} （￥{{ order.plan.price }}</span>
                    <template v-if="order.plan.product_type == 4"> /张</template>
                    <template v-else-if="order.plan.product_type >= 1">{{$t('c.Order.text5')}}</template>
                    <template v-else-if="!order.plan.permanent">{{$t('c.Order.text6')}}</template>
                    ）{{ order.plan.independent == 1 ? $t('c.Order.text7') : "" }}
                </div>
                <div class="mt8" v-if="order.product_type == 0">
                    <span class="black-3">{{$t('c.Order.text8')}}</span>
                    <template v-if="order.plan.permanent">{{$t('c.Order.text9')}}</template>
                    <template v-else>{{ order.month }}{{$t('c.Order.text10')}}</template>
                    <span
                        class="black-3"
                        v-if="order.discount > 0"
                    >（{{$t('c.Order.text11')}} {{ $mixin_discount(order.discount) }}%）</span>
                </div>
                <div class="mt8">
                    <span class="black-3">{{$t('c.Order.text12')}}</span>￥{{ order.total_amount }}<s class="black-3" v-if="order.discount > 0">￥{{ order.show_amount }}</s>
                </div>
                <div class="mt8 flex-box flex-align-items-baseline" v-if="order.remark">
                    <span class="flex-shrink-0 black-3">{{$t('c.Order.text13')}}</span>
                    <pre-box :text="order.remark"></pre-box>
                </div>
                <div class="line mt-24-16 mb-24-16 mq"></div>
                <div class="black-3 fs12">
                    <div class="flex-box">
                        <div v-text="$time_show(order.create_time)"></div>
                        <div class="ml8">
                            <template v-if="order.status == order_status.pending">{{$t('c.Order.text14')}}</template>
                            <template v-if="order.status == order_status.success">{{$t('c.Order.text15')}}</template>
                            <template v-if="order.status == order_status.cancel">{{$t('c.Order.text16')}}</template>
                        </div>
                    </div>
                    <div v-if="order.pay_type == 3" class="break-all mt2">{{$t('c.Order.text17')}} {{host}}/redeem/{{order.redeem_id}}</div>
                    <div v-if="order.plan.need_address && order.ext && order.ext.address" class="mt2">
                        {{$t('c.Order.text18')}}{{order.ext.address.name}} {{order.ext.address.phone}} {{order.ext.address.address}}
                        <!-- <div>{{order.ext.address.address}}</div> -->
                    </div>
                    <div v-if="order.order_attr && order.order_attr.company_id" class="flex-box pointer mt2" @click="mixin_copy(order.order_attr.express_no)">
                        <span>{{order.order_attr.company_name}} {{order.order_attr.express_no}}</span>
                        <span class="black-3 clipboard ml16">{{$t('c.Order.text19')}}</span>
                    </div>
                    <div class="flex-box pointer mt2" @click="mixin_copy(order.out_trade_no)">
                        <div class="">{{$t('c.Order.text20')}}{{ order.out_trade_no }}</div>
                        <span class="ml16" >{{$t('c.Order.text21')}}</span>
                    </div>
                    <div v-if="order.order_attr && order.order_attr.company_id" class="flex-box flex-direction-row-reverse mt16">
                        <btn v-if="order.ext && order.ext.address && order.ext.address.phone" @click.native="$mixin_router_push($encode_uri_express(`/order/delivery?number=${order.order_attr.express_no}&mobile=${order.ext.address.phone}&out_trade_no=${order.out_trade_no}&express_name=${order.order_attr.company_name}`), true)" class="look3 pt8 pr16 pb8 pl16 fs14">{{$t('c.Order.text22')}}</btn>
                        <btn v-else @click.native="$mixin_router_push($encode_uri_express(`/order/delivery?number=${order.order_attr.express_no}&out_trade_no=${order.out_trade_no}&express_name=${order.order_attr.company_name}`), true)" class="look3 pt8 pr16 pb8 pl16 fs14">{{$t('c.Order.text22')}}</btn>
                        <btn v-if="order.product_type == 0" @click.native="feed_jump" class="look3 pt8 pr16 pb8 pl16 fs14 mr16">查看动态</btn>
                    </div>
                     <div v-if="order.plan.need_address && order.order_attr && order.order_attr.express_status == 8 && order.ext && order.ext.address && !order.ext.address.updated_times" class="flex-box flex-direction-row-reverse mt16">
                        <btn @click.native="open_address(order)" class="look3 pt8 pr12 pb8 pl12 fs12">{{$t('c.Order.text23')}}</btn>
                    </div>
                    <div v-if="order.product_type == 0 && !(order.order_attr && order.order_attr.company_id)" class="flex-box flex-direction-row-reverse mt16 flex-a-center">
                      <btn @click.native="feed_jump" class="look3 pt8 pr16 pb8 pl16 fs14">查看动态</btn>
                    </div>
                    <div class="flex-box flex-direction-row-reverse fs12 mt16" v-if="!is_no_order_again && order.status != order_status.success">
                        <div class="flex-box flex-align-items-center" v-if="order.plan.status == plan_status.normal">
                            <div class="black-8 gl-hover-text flex-box flex-direction-row-reverse">
                                <span class="mr16" @click="remove">{{$t('c.Order.text24')}}</span>
                            </div>
                            <btn class="red pt8 pr16 pb8 pl16 fs14" @click.native="jump({ plan_id: order.plan.plan_id })">{{$t('c.Order.text25')}}</btn>
                        </div>
                        <template v-else>
                            <div>
                                <div class="black-8 gl-hover-text flex-box flex-direction-row-reverse flex-align-items-center">
                                    <btn class="red ml16 pt8 pr16 pb8 pl16 fs14" @click.native="jump({user_id: order.user.user_id})">{{$t('c.Order.text25')}}</btn>
                                    <span class="" @click="remove">{{$t('c.Order.text26')}}</span>
                                </div>
                                <div class="black-3 mt8" v-if="order.plan.status == plan_status.delete">
                                    {{$t('c.Order.text27')}}
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="ml24 black-3"><span class="gl-hover-text">取消订单</span></div>-->
    </div>
</template>

<script>
import { mapState } from "vuex";
import { GET_ORDER_CANCEL } from "@/api/config";
import TicketTip from "@/components/TicketTip";

export default {
    name: "order",
    inject:['app_action_sheet'],
    props: {
        order: {
            type: Object,
            default: {},
        },
        is_no_order_again: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },
    components: {
      TicketTip
    },
    data() {
        return {};
    },
    computed: {
        ...mapState("app", ["plan_status", "order_status", "pay_status",'host']),
    },
    beforeDestroy() {
        this.$bus.$off("MODAL_ADDRESS_SUCCESS");
    },
    mounted() {
        this.$bus.$on("MODAL_ADDRESS_SUCCESS", (data) => {
            this.$notify({
                title: '地址设置成功',
                group: "success",
            });
            if(this.order.out_trade_no == data.out_trade_no){
                this.$set(this.order.ext,'address',{
                    address:data.addr_address,
                    phone:data.addr_phone,
                    name:data.addr_name,
                    updated_times:1,
                })
            }
        });
    },
    methods: {
        copy(msg) {
            this.$notify({
                title: msg,
                group: "success",
            });
        },
        jump(query){
            if(this.order.plan.product_type >= 1){
                query = {
                    product_type: this.order.plan.product_type,
                    plan_id: this.order.plan.plan_id,
                    sku: this.order.sku_detail,
                }
            }
            query.out_trade_no = this.order.out_trade_no;
            this.$mixin_router_push(`/order/create?${this.$params(query)}`, true)
        },
        open_qr(){
          this.app_action_sheet('open', {
            component:'action-qr-code',
            classname: 'qr-code',
            params:{
              plan:this.order.plan,
              out_trade_no:this.order.out_trade_no,
            }
          })
        },
        item_jump(){
          if(this.order.plan && this.order.plan.product_type == 4){
            this.$mixin_router_push(`/item/${this.order.plan.plan_id}`)
          }
        },
        tit_jump(){
          let query = ''
          let plan = this.order.plan;
          if(plan && plan.product_type == 0){
            query = {
              plan_id:this.order.plan.plan_id,
              product_type:0,
            }
            this.$mixin_router_push(`/order/create?${this.$params(query)}`, true)
          }
          if(plan && plan.product_type >= 1){
            this.$mixin_router_push(`/item/${this.order.plan.plan_id}`, true)
          }
        },
        feed_jump(){
          let query = ''
          let plan = this.order.plan;
          if(this.order.plan_id == ''){ //自选金额
            query = {  // 所有赞助者
              tab:'home',
              feed_filter_key:'plan_id',
              feed_filter_value:'all_sponsor_can_read',
              pos_feed:1 //定位到feed位置
            }
          }
          if(plan && plan.independent == 1 || (plan.independent == 0 && this.order.plan.plan_id)){ //独立方案  || 普通方案
            query = {  // 所有赞助者
              tab:'home',
              feed_filter_key:'plan_id',
              feed_filter_value: this.order.plan.plan_id,
              pos_feed:1 //定位到feed位置
            }
          }
          if(query){
            this.$mixin_router_push(`/a/${this.order.user.url_slug}?${this.$params(query)}`, true)
          }
        },
        async remove() {
            let re = await this.$mixin_confirm({title:'确认取消吗？'})
            if (!re) {
                return false;
            }

            if (this.$http.is_run(GET_ORDER_CANCEL)) {
                return false;
            }
            let data = await this.$http.$axios(GET_ORDER_CANCEL, {
                out_trade_no: this.order.out_trade_no,
            });

            this.$notify({
                title: data.em,
                group: data.ec == 200 ? "success" : "error",
            });

            if (data.ec == 200) {
                this.$emit("remove");
            }
        },
        open_address(data){
            this.$mixin_show_modal_address({
                out_trade_no: data.out_trade_no,
                addr_address: data.ext.address.address || '' ,
                addr_phone: data.ext.address.phone || '' ,
                addr_name: data.ext.address.name || '',
                tip_text:'仅有一次修改机会'
            })
        }
        // open_express(data){
        //     this.$mixin_show_modal_express({
        //         out_trade_no: data.out_trade_no,
        //         express_no: data.order_attr ? data.order_attr.express_no : '' ,
        //         express:{
        //             id: data.order_attr ? data.order_attr.company_id: '',
        //             name: data.order_attr ? data.order_attr.company_name: ''
        //         }
        //     })
        // }
    },
};
</script>
<style lang="stylus" scoped>
.vm-order {
    background: $white;
    border-radius: px2rem(4);
    border: 1px solid $grey;
    padding: px2rem(24);

    .order-info {
        display: flex;
        position: relative;
    }

    .avatar-item /deep/ {
        padding: px2rem(24);
        box-sizing: border-box;
        background: $white;
        width: 48%;
        // margin-top: 16px;
        border: 1px solid $grey;
        border-radius: px2rem(4);

        &:nth-child(2n+1) {
            margin-right: 4%;
        }

        .vm-avatar /deep/ {
            align-items: center;

            .avatar-content {
                max-width: 60%;
                display: -webkit-box;
                overflow: hidden;
                text-overflow: ellipsis;
                /* autoprefixer: ignore next */
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                white-space: normal;
            }
        }

        .right-info {
            position: absolute;
            top: 16px;
            right: 16px;
            bottom: 16px;
        }
    }
    .vm-plan-sale /deep/{
        .price-box{
            .t1,
            .t2{
                color:$black-3 !important;
                font-size:13px !important;
            }
        }
        .right-box{
            flex:1;
        }
        .vm-btn{
            // position absolute;
            // bottom:16px;
            // right:16px;
            margin-right:16px;
        }
    }
    @media (max-width: $width-mobile) {
        .user-right {
            margin-top: px2rem(8);
            width: 100%;
            display: flex;
            flex-direction: row-reverse;
        }
        .avatar-list {
            flex-direction: column;
        }

        .avatar-item /deep/ {
            background: transparent;
            padding: 0 px2rem(16);
            width: 100%;
            border: 0;
            border-radius: 0;
            margin-right: 0 !important;
            margin-bottom: 24px;

            .right-info {
                top: -2px;
                right: 16px;
                bottom: 0px;
            }
        }
    }
}
</style>
